import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { LoaderService } from '../../../core/services/loader.service';

@Component({
  selector: 'app-global-loader',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, NgOptimizedImage],
  template: `
    <!-- eslint-disable @angular-eslint/template/no-call-expression -->
    @if (isLoading()) {
      <div class="global-loader-overlay">
        <div class="global-loader-container">
          <!-- Modern Spinner with Pulsing Logo -->
          <div class="modern-loader">
            <div class="spinner-container">
              <div class="spinner-ring"></div>
              <div class="spinner-ring"></div>
            </div>
            <img ngSrc="assets/az-logo.svg" alt="AstraZeneca Logo" class="logo-image" width="120" height="120" priority>
          </div>
        </div>
      </div>
    }
  `,
  styleUrls: ['./global-loader.component.scss']
})
export class GlobalLoaderComponent {
  readonly loaderService = inject(LoaderService);
  readonly isLoading = this.loaderService.isLoading;
}
